import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'zf-web-components';

/**
 * 有些 旧页面想保留 title，可以通过这个 hook 来设置
 */
export function useDocumentTitle(): void {
  const [t] = useTranslation();
  const { pathname } = useLocation();
  const titleMap = useMemo<Record<string, string>>(() => ({
    '/shoteyes/detective_detail.html': t('支付记录'),
    '/shoteyes/dashboard.html': t('首页'),
    '/v2/dashboard': t('首页')
  }), [t]);

  useEffect(() => {
    document.title = titleMap[pathname] ?? document.title;
  }, [pathname, titleMap]);
}
